module.exports = __webpack_public_path__ + "img/gonglue_title.69658ea7.png";